export const dataService = {
  aggregateData
};

function aggregateData(chartdata) {

  let rows = [];
  let counter = 0;

  // make a group by function to use below
  Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
      const val = item[prop];
      groups[val] = groups[val] || [];
      groups[val].push(item);
      return groups
    }, {})
  };

  const groupedByDate = chartdata.groupBy('date');
  for(let i in groupedByDate){
    if(groupedByDate.hasOwnProperty(i)){

      let year = '';
      let allMethods = 0;
      let allPragmatics = 0;
      let allAesthetics = 0;
      let allImpacts = 0;

      let group = (groupedByDate[i]);
      year = group[0].date;

      for(let j in group){
        if(group.hasOwnProperty(j)){
          if(group[j].methods !== undefined){
            allMethods += group[j].methods;
          }
          if(group[j].pragmatics !== undefined){
            allPragmatics += group[j].pragmatics;
          }
          if(group[j].aesthetics !== undefined){
            allAesthetics += group[j].aesthetics;
          }
          if(group[j].gatekeeping !== undefined){
            allImpacts += group[j].gatekeeping;
          }
        }
      }

      // find the average
      let groupLength = group.length;
      allMethods = allMethods/groupLength;
      allPragmatics = allPragmatics/groupLength;
      allAesthetics = allAesthetics/groupLength;

      rows[counter] = [];
      rows[counter][0] = year;
      rows[counter][1] = allMethods;
      rows[counter][2] = allPragmatics;
      rows[counter][3] = allAesthetics;
      rows[counter][4] = allImpacts;
    }
    counter++;
    }

    //console.log(rows);
    return rows;

}
